'use strict';

var scrollAnimate = require('../components/scrollAnimate');

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
function loadFormErrors(parentSelector, fieldErrors) { // eslint-disable-line
    // Display error messages and highlight form fields with errors.
    var errorsMsgGeneral = [];
    $.each(fieldErrors, function (attr) {
        $('*[name=' + attr + ']', parentSelector).addClass('is-invalid').siblings('.invalid-feedback').html(fieldErrors[attr]);
        let fieldName = $('*[name=' + attr + ']', parentSelector).parent().find('label').length > 0 ? $('*[name=' + attr + ']', parentSelector).parent().find('label').text()+': ' : '';
        errorsMsgGeneral.push( '<span class="item-error"><b>'+fieldName + '</b>'+ fieldErrors[attr]+'</span>');
    });
    
    // Animate to top of form that has errors
    scrollAnimate($(parentSelector), 170);
    let errorsMsgGeneralHtml = errorsMsgGeneral.join('<br/>');
    let errorMsgGeneralHtmlHeading = $('#checkout-main').length && typeof($('#checkout-main').attr('data-generic-message-header-forms')) !== 'undefined' ? $('#checkout-main').attr('data-generic-message-header-forms') + '<br/>' : '';
    if($('.payment-form .tab-pane[data-method-id="REDSYS_CREDIT_CARD"] .redsys-tab.active')){
        $('#refresh-credit-card-payment').trigger('click');
    }
    $(parentSelector).prepend('<div class="alert alert-danger auto-close">'+ errorMsgGeneralHtmlHeading + errorsMsgGeneralHtml +'</div>');
    setTimeout(() => {
        $(parentSelector).find('.alert').fadeOut('slow');
    }, 5000);
}

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
    $('.error-message, .invalid-feedback').hide();
}

module.exports = {
    loadFormErrors: loadFormErrors,
    clearPreviousErrors: clearPreviousErrors
};
